import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const RecipientLine = ({
  recipientNames = []
}) => {
  const recipientNamesList = recipientNames.join(', ');
  return recipientNames.length ? /*#__PURE__*/_jsx(Text, {
    as: "div",
    color: "text-core-subtle",
    typography: "detail-100",
    paddingInlineEnd: "200",
    paddingBlockEnd: "200",
    marginBlockStart: "-100",
    "data-test-id": "recipient-line",
    children: /*#__PURE__*/_jsx(TruncateString, {
      hideDefaultTooltip: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-message-history.common-message.recipientLine',
        options: {
          recipientNamesList
        }
      })
    })
  }) : null;
};
RecipientLine.displayName = 'RecipientLine';
export default RecipientLine;